import React, { useState } from "react";
import { TextField, Button, Typography, Box, Checkbox, FormControlLabel } from "@mui/material";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [street, setStreet] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [region, setRegion] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [country, setCountry] = useState("");
    const [contactAgree, setContactAgree] = useState({
      buyingHouses: false,
      sellingHouses: false,
      investing: false,
      realEstateAgent: false,
    });

  const handleContactAgree = (event) => {
    const { name, checked } = event.target;
    setContactAgree((prev) => ({ ...prev, [name]: checked }));
  };

const handleSubmit = async () => {
  const entryData = {
    name,
    email,
    phone,
    street,
    address2,
    city,
    region,
    zipcode,
    country,
    contactAgree
  };

  console.log("New Giveaway Entry:", entryData);

  try {
    const res = await fetch("http://localhost:3001/api/submit-entry", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(entryData)
    });

    if (res.ok) {
      console.log("Successfully saved to MongoDB");
    } else {
      console.error("Failed to save entry");
    }
  } catch (err) {
    console.error("Submission error:", err);
  }
};

  return (
    <><Box
          sx={{
              width: '100%',
              maxWidth: 400,
              mx: 'auto',
              mt: 8,
              p: 3,
              boxShadow: 3,
              borderRadius: 2,
              textAlign: 'center',
          }}
      >
          <Typography variant="h5" gutterBottom>
              Enter to Win!
          </Typography>

          {/* Name */}
          <TextField
              fullWidth
              label="Full Name"
              margin="normal"
              value={name}
              onChange={(e) => setName(e.target.value)} />

          {/* Email */}
          <TextField
              fullWidth
              label="Email"
              type="email"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)} />

            {/* Phone */}
            <TextField
              fullWidth
              label="Phone Number"
              margin="normal"
              value={phone}
              onChange={(e) => setPhone(e.target.value)} />

            {/* Address */}
            <TextField
              fullWidth
              label="Street Address"
              margin="normal"
              value={street}
              onChange={(e) => setStreet(e.target.value)} />

            <TextField
              fullWidth
              label="Address Line 2"
              margin="normal"
              value={address2}
              onChange={(e) => setAddress2(e.target.value)} />

            <TextField
              fullWidth
              label="City"
              margin="normal"
              value={city}
              onChange={(e) => setCity(e.target.value)} />

            <TextField
              fullWidth
              label="State / Province / Region"
              margin="normal"
              value={region}
              onChange={(e) => setRegion(e.target.value)} />

            <TextField
              fullWidth
              label="Postal / Zip Code"
              margin="normal"
              value={zipcode}
              onChange={(e) => setZipcode(e.target.value)} />

            <TextField
              fullWidth
              label="Country"
              margin="normal"
              value={country}
              onChange={(e) => setCountry(e.target.value)} />
       
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              {/* Interest Checkboxes */}
              <FormControlLabel
                  control={<Checkbox
                      checked={contactAgree}
                      onChange={handleContactAgree}
                      name="contactAgree" />}
                  label="By entering the RocketOffer.com Giveaway, I agree to being contacted by the organizer if I am selected as the winner or to receive marketing communications." />
              {/* Submit Button */}
              <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                  onClick={handleSubmit}
              >
                  Enter
              </Button>
          </Box>
          </>
  );
};

export default Register;